import { useEffect, useState } from "react";

const RecitationSettings=()=>{
    const [enableAutoplay, setEnableAutoplay] = useState(localStorage.getItem('autoPlaySetting') === 'true' || false);

    const toggleAutoplay=()=>{
        const newAutoplayStatus=!enableAutoplay;
        localStorage.setItem('autoPlaySetting',newAutoplayStatus);
        setEnableAutoplay(newAutoplayStatus);
    }

    return(
        <div id="settingsRecitation">
            <h4 className="text-white my-6">Autoplay</h4>
            <label className="relative inline-flex items-center cursor-pointer w-full">
                <input type="checkbox" checked={enableAutoplay} className="sr-only peer" onChange={toggleAutoplay}/>
                <span className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></span>
                <span id="autoplayLabel" className="ml-3 text-sm font-medium text-white">{`Load next ${location.pathname.includes('/quran/read-mushaf/')?`page`:`surah`} automatically`}</span>
            </label>
        </div>
    )
}

export default RecitationSettings;